import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { CollegeBatchConstant } from 'src/app/constants/label-constants';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-college-batch-view',
  templateUrl: './college-batch-view.component.html',
  styleUrls: ['./college-batch-view.component.scss']
})
export class CollegeBatchViewComponent {
  CollegeBatchForm: FormGroup = this.formBuilder.group({});
  collegeBatchId:number =0;
  CollegeBatchList: any = [];
  CommonConstant:any=[];
  CollegeBatchConstant:any=[];
  collegeList:any=[];
  flag: boolean=false;
  constructor(
    private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private apiUrl: ApiUrlHelper,
    public modalService: NgbActiveModal,
    private spinner:NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.CollegeBatchConstant = CollegeBatchConstant;
    this.CommonConstant = CommonConstant
    this.getCollageBatchDetail(this.collegeBatchId);
    this.getCollegeList();
  }

  getCollageBatchDetail(collegeBatchId: number) { 
    const apiUrl = this.apiUrl.apiUrl.collageBatch.GetCollegeByIdBatch.replace("{id}", collegeBatchId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.CollegeBatchList = data.data[0]
      },
      error: (err) => {
        console.log('getCollageBatchDetail-Error', err);
      }
    });
  }
  
  getCollegeList() {
    const apiUrl = this.apiUrl.apiUrl.college.GetCollegeListForDropDown;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.collegeList.push({ 'id': data.data[i].collegeId, 'value': data.data[i].collegeName })
          }
        }
        this.spinner.hide();
        this.flag = true;
      },
      error: (err) => {
        console.log('getHandlerList-Error', err);
      }
    });
  }
}
